function removeWhitespace(str: string): string {
    return str?.replace(/\s/g, '');
}

const slugify = (text: string): string => {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};

function objectToText(obj: Record<string, unknown>): string {
    return Object.keys(obj)
        .map((key) => `${key}=${obj[key]}`)
        .join('&');
}

function studly(str: string): string {
    return str
        .toLowerCase()
        .split(/[_\-\s]+/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}

export { removeWhitespace, objectToText, slugify, studly };
